fragment PeepLabelOptionsFragment on PeepLabelOptions {
    phones
    emailAddresses
    postalAddresses
    urls
}
